
Greenmile.EventNotifications = Greenmile.EventNotifications || {};
Greenmile.EventNotifications.Driver = Greenmile.EventNotifications.Driver || {};
Greenmile.EventNotifications.Driver.TableView = Greenmile.EventNotifications.Driver.TableView || {};

Greenmile.EventNotifications.Driver.TableView = (function () {

    function DriverTableView (driverAssignments) {

        this.setEquipment = function (equipment) {

            if (equipment && equipment.id) {
                this.equipmentId = equipment.id;
            }

        };

        const phoneFieldDomains = {
            '0': 'phoneType.workPhone',
            '1': 'phoneType.homePhone',
            '3': 'phoneType.cellularPhone',
            '4': 'phoneType.fax'
        };

        this.getPhonesTableView = function (phones) {
            const lines = { data: [] };

            for (let i = 0, length = phones.length; i < length; i++) {

                const phone = phones[i];
                const phoneType = Monet.I18n.getResourcesByKey(phoneFieldDomains[phone.type]);

                lines.data.push([
                    new Monet.UI.TableViewCell('TEXT', phoneType),
                    new Monet.UI.TableViewCell('TEXT', phone.number),
                    new Monet.UI.TableViewCell('ICON', {
                        className: 'phone' + (i + 1) + ' phonePopupMap',
                        href: 'callto:' + phone.number
                    })
                ]);
            }

            if (lines.data.length > 0) {
                const grid = new Monet.UI.TableView();
                grid.setLines(lines);
                return grid.render();
            }
        };

        this.getMobileDeviceLog = function (equipmentId) {

            if (equipmentId) {

                const ajax = new Monet.Ajax();
                ajax.url = "Equipment/" + equipmentId + "/RouteStatus";
                ajax.method = 'GET';

                ajax.success = (function (scope) {
                    return function (routeStatus) {

                        if (routeStatus) {
                            const driversInfos = routeStatus.driversInfo;

                            if (driversInfos && driversInfos.length > 0) {

                                for (let i = 0, length = driversInfos.length; i < length; i++) {
                                    const phonesInfo = driversInfos[i].phoneInfos;
                                    const phonesList = [];

                                    for (let j = 0, phonesInfoLength = phonesInfo.length; j < phonesInfoLength; j++) {
                                        phonesList.push({ type: phonesInfo[j].phoneType, number: phonesInfo[j].phone });
                                    }

                                    const baseElSelector = '#tooltipDetalheEvento .allContentDriverTab .driverInfo[driverkey="' + driversInfos[i].key + '"]';
                                    const contentDriverInfo = document.querySelector(baseElSelector);
                                    let tableView = scope.getPhonesTableView(phonesList);

                                    if (contentDriverInfo) {

                                        const previousTableView = contentDriverInfo.querySelector('.BaseMonetUITableView');
                                        if (previousTableView) {
                                            contentDriverInfo.removeChild(previousTableView);
                                        }

                                        if (tableView) {

                                            tableView.setAttribute('driverKey', driversInfos[i].key);
                                            contentDriverInfo.appendChild(tableView);

                                        }

                                    }

                                }
                            }
                        }

                    };
                }(this));

                ajax.error = function () {
                    console.log('No mobileDeviceLog found');
                };

                ajax.send();
            }
        };

        this.getDriversTabContent = function () {

            const baseEl = document.createElement('div');
            baseEl.className = 'allContentDriverTab';

            if (driverAssignments) {

                for (let i = 0, length = driverAssignments.length; i < length; i++) {

                    const driver = driverAssignments[i];
                    const driverInfo = document.createElement('div');
                    driverInfo.className = 'driverInfo';
                    driverInfo.setAttribute('driverkey', driver.key);

                    const driverHeader = document.createElement('div');
                    driverHeader.className = 'EventNotificationTabHeader ' + driver.key;
                    driverHeader.appendChild(document.createTextNode(driver.key + ' - ' + driver.name));
                    driverInfo.appendChild(driverHeader);

                    baseEl.appendChild(driverInfo);

                    const phones = [];
                    if (driver.phone1) {
                        phones.push({ type: driver.phone1Type, number: driver.phone1 });
                    }

                    if (driver.phone2) {
                        phones.push({ type: driver.phone2Type, number: driver.phone2 });
                    }

                    const tableView = this.getPhonesTableView(phones);
                    if (tableView) {
                        tableView.setAttribute('driverKey', driver.key);
                        driverInfo.appendChild(tableView);
                    }

                    this.getMobileDeviceLog(this.equipmentId);
                }
            }

            return baseEl;
        };

    }

    return DriverTableView;

})();

